import { useMediaQuery } from "react-responsive";

export const smMobile = "(max-width: 24rem)"; //384px
export const mobile = "(max-width: 30rem)"; //480px
export const tablet = "(max-width: 48rem)"; //768px
export const tabletLarge = "(max-width: 64rem)"; //1024px (Ipad Pro)
export const mobileShort = "(max-height: 34.6rem)";

export const useQuery = () => ({
  isSmMobile: useMediaQuery({ query: smMobile }),
  isMobile: useMediaQuery({ query: mobile }),
  isTablet: useMediaQuery({ query: tablet }),
  isTabletLarge: useMediaQuery({ query: tabletLarge }),
  isMobileShort: useMediaQuery({ query: mobileShort }),
});
